import { inject, NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { CommonModule } from '@angular/common';
import {
    faArrowDown as faArrowDownSolid,
    faArrowLeftLong as faArrowLeftLongSolid,
    faArrowRightLong as faArrowRightLongSolid,
    faArrowUp as faArrowUpSolid,
    faCheck as faCheckSolid,
    faCircleCheck as faCircleCheckSolid,
    faCircleExclamation as faCircleExclamationSolid,
    faCircleInfo as faCircleInfoSolid,
    faHandshake as faHandshakeSolid,
    faLock as faLockSolid,
    faMagnifyingGlass as faMagnifyingGlassSolid,
    faPlus as faPlusSolid,
    faSpinner as faSpinnerSolid,
    faTags as faTagsSolid,
    faTrash as faTrashSolid,
    faUsers as faUsersSolid,
    faUser as faUserSolid,
    faXmark as faXmarkSolid,
    faBuildingUser as faBuildingUserSolid,
    faChartLine as faChartLineSolid,
    faUpload as faUploadSolid,
    faDownload as faDownloadSolid,
    faCalendarDays as faCalendarDaysSolid,
    faAddressCard as faAddressCardSolid,
    faInbox as faInboxSolid,
    faFilter as faFilterSolid,
    faFilterCircleXmark as faFilterCircleXmarkSolid,
    faCalendar as faCalendarSolid,
    faCalendarDay as faCalendarDaySolid,
    faFileContract as faFileContractSolid,
    faRightFromBracket as faRightFromBracketSolid,
    faArrowUpRightFromSquare as faArrowUpRightFromSquareSolid,
    faEnvelope as faEnvelopeSolid,
    faHouse as faHouseSolid,
    faCoins as faCoinsSolid,
    faHeadset as faHeadsetSolid,
    faBoxOpen as faBoxOpenSolid,
    faBell as faBellSolid
} from '@fortawesome/free-solid-svg-icons';
import {} from '@fortawesome/free-regular-svg-icons';
import { IconComponent } from './components/icon/icon/icon.component';
import { IconButtonComponent } from './components/icon-button';

const SOLID_ICONS: IconDefinition[] = [
    faArrowDownSolid,
    faArrowLeftLongSolid,
    faArrowRightLongSolid,
    faArrowUpSolid,
    faCheckSolid,
    faCircleCheckSolid,
    faCircleExclamationSolid,
    faCircleInfoSolid,
    faHandshakeSolid,
    faLockSolid,
    faMagnifyingGlassSolid,
    faPlusSolid,
    faSpinnerSolid,
    faTagsSolid,
    faTrashSolid,
    faUsersSolid,
    faUserSolid,
    faXmarkSolid,
    faBuildingUserSolid,
    faChartLineSolid,
    faUploadSolid,
    faDownloadSolid,
    faCalendarDaysSolid,
    faAddressCardSolid,
    faInboxSolid,
    faFilterSolid,
    faFilterCircleXmarkSolid,
    faCalendarSolid,
    faCalendarDaySolid,
    faFileContractSolid,
    faRightFromBracketSolid,
    faArrowUpRightFromSquareSolid,
    faEnvelopeSolid,
    faHouseSolid,
    faCoinsSolid,
    faHeadsetSolid,
    faBoxOpenSolid,
    faBellSolid
];

const REGULAR_ICONS: IconDefinition[] = [];

const COMPONENTS = [IconComponent, IconButtonComponent];

@NgModule({
    declarations: [...COMPONENTS],
    imports: [CommonModule, FontAwesomeModule],
    exports: [...COMPONENTS, FontAwesomeModule]
})
export class IconsModule {
    private readonly faIconLibrary = inject(FaIconLibrary);

    public constructor() {
        this.faIconLibrary.addIcons(...SOLID_ICONS, ...REGULAR_ICONS);
    }
}
